import { IQueryParams } from '../../../../models/index';
import {
  clearSourceRegistryListDetails,
  fetchSourceRegistryListFail,
  fetchSourceRegistryListStarted,
  fetchSourceRegistryListSuccess
} from '../../../reducer/sources/SourceRegistryListReducer';
import { fetchSourceRegistryList } from '../../actionType/sources/SourceRegistryListActionTypes';
import {
  ClearAllSourceRegistriesList,
  FetchAllSourceRegistriesFailure,
  FetchAllSourceRegistriesFailurePayload,
  FetchAllSourceRegistriesRequest,
  FetchAllSourceRegistriesStarted,
  FetchAllSourceRegistriesSuccess,
  FetchAllSourceRegistriesSuccessPayload
} from '../../types/sources/GetAllSourceRegistries';

export const fetchSourceRegistryListRequest = (
  pageNo: number,
  item: number,
  queryParams?: IQueryParams,
  sort?: string
): FetchAllSourceRegistriesRequest => ({
  type: fetchSourceRegistryList.FETCH_SOURCE_REGISTRY_LIST_REQUEST,
  pageNo,
  item,
  queryParams,
  sort
});

/**
 * Fetch All source registry  started saga action
 * @returns source registry started action
 */
export const getAllSourceRegistryStarted = (): FetchAllSourceRegistriesStarted => ({
  type: fetchSourceRegistryListStarted.type
});

/**
 * Fetch all source registry success saga action
 * @param payload : all source registry data
 * @returns success action
 */
export const getAllSourceRegistrySuccess = (
  payload: FetchAllSourceRegistriesSuccessPayload
): FetchAllSourceRegistriesSuccess => ({
  type: fetchSourceRegistryListSuccess.type,
  payload
});

/**
 * Fetch All source registry Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const fetchAllSourceRegistryFailure = (
  payload: FetchAllSourceRegistriesFailurePayload
): FetchAllSourceRegistriesFailure => ({
  type: fetchSourceRegistryListFail.type,
  payload
});

/**
 * Clear All Source Registry saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearAllSourceRegistry = (): ClearAllSourceRegistriesList => ({
  type: clearSourceRegistryListDetails.type
});
